@if (showErrorMessage) {
<div class="errorMessage">
  <nh-alert type="danger" [isOpen]="showErrorMessage">
    <div class="row">
      <div class="col-auto icon">
        <img
          src="../../../assets/images/Icons/⚛️ icons-alert-circle-outline.svg"
          alt=""
        />
      </div>
      <div class="col message">
        <span>{{ "ERROR_ADDRESS" | globalTranslate }}</span>
      </div>
    </div>
  </nh-alert>
</div>
}

<div class="modal-content people-delete">
  <form [formGroup]="form">
    <div class="modal-header">
      <h1 class="modal-title pull-left" id="my-modal-title">
        {{ this.title | globalTranslate }}
      </h1>
      <button
        type="button"
        class="btn-close pull-right"
        [attr.aria-label]="'CLOSE' | globalTranslate"
        (click)="onCancel()"
      >
        <img
          src="../../assets/images/⚛️ icons-close-circle-outline.svg"
          alt="close-icon"
        />
      </button>
    </div>
    <div class="modal-body">
      <div>
        <h2 class="section-header">
          {{ this.fullName }}
          {{ "PEOPLE_DELETE_STATIC_TEXT1" | globalTranslate }}
        </h2>
        <hr />
        <p class="hint-label">
          {{ "PEOPLE_DELETE_STATIC_TEXT2" | globalTranslate }}
          {{ this.fullName }}
          {{ "PEOPLE_DELETE_STATIC_TEXT3" | globalTranslate }}
          {{ this.fullName }}
          {{ "PEOPLE_DELETE_STATIC_TEXT4" | globalTranslate }}
        </p>

        <div>
          <nh-field
            [attr.aria-required]="true"
            label="{{ 'PEOPLE_DELETE_STATIC_TEXT5' | globalTranslate }} {{
              this.fullName
            }} {{ 'PEOPLE_DELETE_STATIC_TEXT6' | globalTranslate }}"
            [isRow]="true"
            [mandatory]="true"
          >
            <select
              nhTranslate
              [name]="'remove_reason'"
              (change)="onDateChange(this.form.value.deleteReason.code)"
              [items]="this.modifiedReasons"
              [required]="true"
              [attr.aria-label]="
                ('PEOPLE_DELETE_STATIC_TEXT5' | globalTranslate) +
                ' ' +
                this.fullName +
                ' ' +
                ('PEOPLE_DELETE_STATIC_TEXT6' | globalTranslate)
              "
              formControlName="deleteReason"
            ></select>
          </nh-field>
        </div>

        @if (this.form.value.deleteReason?.code === 'MO') {
        <div>
          <nh-field
            [attr.aria-required]="false"
            label="{{ 'WHEN_DID_2' | globalTranslate }} {{ this.fullName }} {{
              'PEOPLE_DELETE_STATIC_TEXT7' | globalTranslate
            }}"
            [isRow]="true"
            [mandatory]="false"
          >
            <nh-datepicker>
              <input
                type="text"
                name="indvDeletedDate"
                class="form-control"
                formControlName="indvDeletedDate"
                [attr.aria-label]="
                  ('WHEN_DID_2' | globalTranslate) +
                  ' ' +
                  this.fullName +
                  ' ' +
                  ('PEOPLE_DELETE_STATIC_TEXT7' | globalTranslate)
                "
                bsDatepicker
                nh
                [minDate]="minDate"
                [maxDate]="today"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.form.value.deleteReason?.code === 'DE') {
        <div>
          <nh-field
            [attr.aria-required]="this.form.value.deleteReason?.code === 'DE'"
            label="{{ 'PEOPLE_DELETE_STATIC_TEXT8' | globalTranslate }}"
            [isRow]="true"
            [mandatory]="this.form.value.deleteReason?.code === 'DE'"
          >
            <nh-datepicker>
              <input
                type="text"
                name="deathDate"
                class="form-control"
                formControlName="deathDate"
                [attr.aria-label]="
                  'PEOPLE_DELETE_STATIC_TEXT8' | globalTranslate
                "
                bsDatepicker
                [required]="this.form.value.deleteReason?.code === 'DE'"
                nh
                [minDate]="minDate"
                [maxDate]="today"
              />
            </nh-datepicker>
          </nh-field>
        </div>
        } @if (this.form.value.deleteReason?.code === 'MO') {
        <div>
          <p class="hint-label">
            {{ "PEOPLE_DELETE_NEW_ADDRESS_TEXT1" | globalTranslate }}
            {{ this.fullName }}
            {{ "PEOPLE_DELETE_NEW_ADDRESS_TEXT2" | globalTranslate }}
          </p>
          <div>
            <nh-field
              [attr.aria-required]="false"
              name="moveOutAddressFormat"
              [isRow]="true"
              [mandatory]="false"
              label="{{ 'ADDRESS_FORMAT' | globalTranslate }}"
            >
              <select
                nh
                name="moveOutAddressFormat"
                [items]="ADDRESSFORMATTYPES"
                [attr.aria-label]="'ADDRESS_FORMAT' | globalTranslate"
                formControlName="moveOutAddressFormat"
                (change)="onChange(this.form.value.moveOutAddressFormat)"
                [required]="'false'"
              ></select>
            </nh-field>
          </div>
          <div class="rounded">
            <div formGroupName="moveOutAddress">
              <div class="row g-3">
                <div class="col-md-8">
                  <nh-field
                    [attr.aria-required]="false"
                    [isRow]="true"
                    [mandatory]="false"
                    label="{{ 'ADDRESS_LINE_1' | globalTranslate }}"
                  >
                    <input
                      type="text"
                      name="addressLine1"
                      formControlName="addressLine1"
                      [attr.aria-label]="'ADDRESS_LINE_1' | globalTranslate"
                      (change)="
                        onChange(this.form.value.moveOutAddress.addressLine1)
                      "
                      class="form-control"
                      maxlength="50"
                      placeholder="105 Johnson Street"
                    />
                  </nh-field>
                </div>
                <div class="col-md-8">
                  <nh-field
                    [attr.aria-required]="false"
                    [isRow]="true"
                    [mandatory]="false"
                    label="{{ 'ADDRESS_LINE_2' | globalTranslate }}"
                  >
                    <input
                      type="text"
                      class="form-control"
                      name="addressLine2"
                      formControlName="addressLine2"
                      [attr.aria-label]="'ADDRESS_LINE_2' | globalTranslate"
                      (change)="
                        onChange(this.form.value.moveOutAddress.addressLine2)
                      "
                      maxlength="30"
                      placeholder="Apt 305"
                    />
                  </nh-field>
                </div>
                @if (this.form.value.moveOutAddressFormat === null ||
                this.form.value.moveOutAddressFormat?.code === 'US') {
                <div class="col-md-8">
                  <nh-field
                    [attr.aria-required]="false"
                    [isRow]="true"
                    [mandatory]="false"
                    label="{{ 'CITY' | globalTranslate }}"
                  >
                    <input
                      type="text"
                      name="city"
                      formControlName="city"
                      [attr.aria-label]="'CITY' | globalTranslate"
                      maxlength="25"
                      (change)="onChange(this.form.value.moveOutAddress.city)"
                      class="form-control"
                    />
                  </nh-field>
                </div>
                }
                <div class="row g-3">
                  @if (this.form.value.moveOutAddressFormat === null ||
                  this.form.value.moveOutAddressFormat?.code === 'US') {
                  <div class="col-6">
                    <nh-field
                      [attr.aria-required]="false"
                      [isRow]="true"
                      [mandatory]="false"
                      label="{{ 'STATE' | globalTranslate }}"
                    >
                      <select
                        nhTranslate
                        name="state"
                        [items]="STATE"
                        bindLabel="code"
                        [attr.aria-label]="'STATE' | globalTranslate"
                        formControlName="state"
                        (change)="
                          onChange(this.form.value.moveOutAddress.state)
                        "
                        [required]="'false'"
                      ></select>
                    </nh-field>
                  </div>
                  } @if (this.form.value.moveOutAddressFormat?.code === 'MI') {
                  <div class="col-6">
                    <nh-field
                      [attr.aria-required]="false"
                      [isRow]="true"
                      [mandatory]="false"
                      label="{{ 'APO_FPO' | globalTranslate }}"
                    >
                      <select
                        nh
                        name="addrApoFpo"
                        [items]="MILITARYPOCODES"
                        [attr.aria-label]="'APO_FPO' | globalTranslate"
                        formControlName="addrApoFpo"
                        [required]="'false'"
                      ></select>
                    </nh-field>
                  </div>
                  } @if (this.form.value.moveOutAddressFormat?.code === 'MI') {
                  <div class="col-6">
                    <nh-field
                      [attr.aria-required]="false"
                      [isRow]="true"
                      [mandatory]="false"
                      label="{{ 'AA_AE_AP' | globalTranslate }}"
                    >
                      <select
                        nh
                        name="addrAaAeAp"
                        [items]="STATEMILITARY"
                        [attr.aria-label]="'AA_AE_AP' | globalTranslate"
                        formControlName="addrAaAeAp"
                        [required]="'false'"
                      ></select>
                    </nh-field>
                  </div>
                  }
                  <div class="col-6">
                    <nh-field
                      [attr.aria-required]="false"
                      [isRow]="true"
                      [mandatory]="false"
                      label="{{ 'ZIP_CODE' | globalTranslate }}"
                    >
                      <input
                        type="text"
                        name="zip"
                        formControlName="zip"
                        [attr.aria-label]="'ZIP_CODE' | globalTranslate"
                        (change)="onChange(this.form.value.moveOutAddress.zip)"
                        class="form-control"
                        mask="00000-0000"
                        [validation]="false"
                        pattern=""
                        placeholder="XXXXX-XXXX"
                      />
                    </nh-field>
                  </div>
                </div>
                @if (this.form.value.moveOutAddress.state?.code === 'TN') {
                <div class="col-6">
                  <nh-field
                    [attr.aria-required]="false"
                    [isRow]="true"
                    [mandatory]="false"
                    label="{{ 'COUNTY' | globalTranslate }}"
                  >
                    <select
                      nh
                      name="county"
                      [items]="COUNTY"
                      [attr.aria-label]="'COUNTY' | globalTranslate"
                      formControlName="county"
                      (change)="onChange(this.form.value.moveOutAddress.county)"
                      [required]="'false'"
                    ></select>
                  </nh-field>
                </div>
                }
              </div>
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="modal-footer d-block button-conatiner">
      <div class="row g-3 justify-content-start">
        <div class="col-md-3 order-md-1 mt-md-0">
          @if (showConfirm) {
          <button
            type="button"
            id="dialog"
            [attr.disabled]="isDisabled"
            class="btn btn-primary onSubmit"
            [attr.aria-label]="'SUBMIT' | globalTranslate"
            [attr.aria-label]="'SUBMIT' | globalTranslate"
            (click)="onConfirm()"
          >
            {{ "SUBMIT" | globalTranslate }}
          </button>
          }
        </div>
        <div class="col-md-3 order-md-2 mt-md-0">
          @if (showDecline) {
          <button
            type="button"
            id="dialog"
            class="btn btn btn-link onCancel"
            [attr.aria-label]="'CANCEL' | globalTranslate"
            [attr.aria-label]="'CANCEL' | globalTranslate"
            (click)="onCancel()"
          >
            {{ declineButton | globalTranslate }}
          </button>
          }
        </div>
      </div>
    </div>
  </form>
</div>